
export function convertISODate(getDate) {
	let convertDate = new Date(getDate).toDateString();
	let splitDate = convertDate.split(" ");
	let sendDate = `${splitDate[3]}-${splitDate[1]}-${splitDate[2]}`;
	return sendDate;
}

export function convertDateFormat(getDate) {
	let convertDate = new Date(getDate).toDateString();
	let splitDate = convertDate.split(" ");
	let sendDate = `${splitDate[2]}-${splitDate[1]}-${splitDate[3]}`;
	return sendDate;
}